export default __webpack_public_path__ + "scene4_3_bg491eb5.png";